module.exports = __webpack_public_path__ + "static/img/blog-07.d5211d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/blog-07.jpg
// module id = l4Y5
// module chunks = 7